module.exports = __webpack_public_path__ + "img/Heavy_Full_Metal_Sword.ababad8d.png";